/* istanbul ignore file */

import Vue from "vue";
import Vuex from "vuex";
import checkout from "./modules/checkout";
import checkoutPayment from "./modules/checkoutPayment";
import global from "./modules/global";
import productShow from "./modules/productShow";
import vendorsIndex from "./modules/vendorsIndex";
import lists from "./modules/lists";
import eventShow from "./modules/eventShow";
import shoppingCart from "./modules/shoppingCart";
import shoppingList from "./modules/shoppingList";
import flashMessages from "./modules/flashMessages";
import lytics from "./modules/lytics";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    checkout,
    checkoutPayment,
    global,
    productShow,
    vendorsIndex,
    eventShow,
    shoppingCart,
    shoppingList,
    flashMessages,
    lists,
    lytics,
  },
});
